<template>

    <div class="bg-secondary py-5">

        <inertia-head title="Confirmed">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 600px;">
                    <div class="card rounded-3 shadow border-0">
                        <div class="card-body text-center">
                            <div class="mb-2">
                                <i class="bi bi-check-circle display-2 text-success"></i>
                            </div>
                            <p>{{ __('OK, die Bestellung :order wurde von Ihnen angenommen und der Kunde per E-Mail benachrichtigt.', {order: orderNumber}) }}</p>
                            <hr />
                            <inertia-link class="btn btn-outline-primary" :href="route('home')">
                                {{ __('Zur Startseite') }}
                            </inertia-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    export default {
        layout: SlimLayout,
        props: [
            'orderNumber',
        ],
        data() {
            return {
            }
        },
        components: {
        },
        computed: {
        },
    }
</script>
